<div class="socio">
  <p class="tab-state" *ngIf="loading">{{ 'common.loading' | translate }}</p>
  <p class="tab-state error" *ngIf="!loading && error">{{ 'audiences.additionalInfo.sociodemo.error' | translate }}</p>
  <p class="tab-state" *ngIf="!loading && !error && !hasData">{{ 'audiences.additionalInfo.sociodemo.empty' | translate }}</p>

  <ng-container *ngIf="!loading && !error && hasData">
    <!-- Gender split -->
    <div class="socio__gender">
      <button type="button" class="gender-bar gender-bar--male" [class.is-active]="selectedGender === 'male'"
              (click)="selectGender('male')">
        <span class="gender-bar__head">
          <span class="gender-bar__label">{{ 'audiences.additionalInfo.sociodemo.male' | translate }}</span>
          <span class="gender-bar__pct">{{ malePercent | number:'1.0-1' }}%</span>
        </span>
        <span class="gender-bar__track"><span class="gender-bar__fill" [style.width.%]="malePercent"></span></span>
      </button>
      <button type="button" class="gender-bar gender-bar--female" [class.is-active]="selectedGender === 'female'"
              (click)="selectGender('female')">
        <span class="gender-bar__head">
          <span class="gender-bar__label">{{ 'audiences.additionalInfo.sociodemo.female' | translate }}</span>
          <span class="gender-bar__pct">{{ femalePercent | number:'1.0-1' }}%</span>
        </span>
        <span class="gender-bar__track"><span class="gender-bar__fill" [style.width.%]="femalePercent"></span></span>
      </button>
    </div>

    <!-- Age breakdown -->
    <div class="socio__ages">
      <div class="socio__ages-head">
        <span>{{ 'audiences.additionalInfo.sociodemo.ageBreakdown' | translate }}</span>
        <span class="socio__ages-scope">{{ 'audiences.additionalInfo.sociodemo.' + selectedGender | translate }}</span>
      </div>
      <div class="age-row" *ngFor="let bar of ageBars; trackBy: trackByLabel">
        <span class="age-row__label">{{ bar.label }}</span>
        <span class="age-row__track"><span class="age-row__fill" [class]="'age-row__fill--' + selectedGender" [style.width.%]="bar.percent"></span></span>
        <span class="age-row__pct" [title]="formatNumber(bar.count)">{{ bar.percent | number:'1.0-1' }}%</span>
      </div>
      <p class="tab-state" *ngIf="!ageBars.length">{{ 'audiences.additionalInfo.sociodemo.noAges' | translate }}</p>
    </div>
  </ng-container>
</div>
